import Utils from "../utils.js";

const DeviceFilter = (function () {
  let selectedOptions = {};
  let queryResultsEl

  function collectFilters() {
    const filterGroups = document.getElementsByClassName(
      "devices-archive__filter-options"
    );

    for (let group of filterGroups) {
      const filterOptions = group.getElementsByClassName("touchit-checkbox");
      const filterKey = group.dataset.filterKey;
      selectedOptions[filterKey] = [];

      for (let option of filterOptions) {
        if (option.checked) {
          selectedOptions[filterKey].push(option.value);
        }
      }
    }
  }

  const debouncedFilterHandler = Utils.debounce(async (event) => {
    if (event.target.classList.contains("touchit-checkbox")) {
      toggleOption(
        event.target.dataset.filterKey,
        event.target.value,
        event.target.checked
      );
      updateFilterUrl();
      const results = await getFilteredResults(selectedOptions);
      updateResults(results);
      Utils.toggleLoading(false, queryResultsEl)
    }
  }, 500);

  function toggleOption(key, option, val) {
    if (true === val) {
      selectedOptions[key].push(option);
    } else {
      const index = selectedOptions[key].indexOf(option);
      if (index > -1) {
        selectedOptions[key].splice(index, 1);
      }
    }
  }

  function updateFilterUrl() {
    const params = new URLSearchParams();
    const nonEmpty = {};

    let size = 0;

    for (let group in selectedOptions) {
      if (selectedOptions[group].length > 0) {
        nonEmpty[group] = selectedOptions[group];
        size++;
      }
    }
    params.delete("filter");
    params.set("filter", JSON.stringify(nonEmpty));

    let newUrl;

    if (size > 0) {
      newUrl = `${window.location.pathname}?${params.toString()}`;
    } else {
      newUrl = `${window.location.pathname}`;
    }

    history.pushState({}, "", newUrl);
  }

  async function getFilteredResults(filterObj) {
    const path = window.location.pathname.split("/").filter(Boolean);
    const category = path[path.length - 1];
    try {
      const response = await fetch(
        "/wp-admin/admin-ajax.php?action=filter_devices",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ filter: filterObj, category: category }),
        }
      );

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }

      const html = await response.text();
      return html;
    } catch (error) {
      console.error("There was a problem with the filter request:", error);
      return "";
    }
  }

  function updateResults(results) {
    queryResultsEl.innerHTML = results;
  }

  return {
    init: function () {
      queryResultsEl = document.getElementById("devicesResults");
      const filterEl = document.getElementById("deviceFilter");

      if (!queryResultsEl || !filterEl) return;

      collectFilters();

      if (window.innerWidth <= 768) {
        Utils.makeItemCollapsibleByHeight(filterEl, 0, "Filter")
      }

      filterEl.addEventListener("input", (event) => {
        Utils.toggleLoading(true, queryResultsEl)
        debouncedFilterHandler(event);
      });
    },
  };
})();

export default DeviceFilter;

document.addEventListener("DOMContentLoaded", () => {
  DeviceFilter.init();
});